import { connect } from 'react-redux';
import SpeakerAudioSwitch from './ScribeSpeakerAudioSwitch';
export default connect((state) => ({
    status: state.scribeConversation.status,
}))(SpeakerAudioSwitch);
